/**
 * Created by yaniv on 10/8/17.
 *
 * This directive adds social share buttons.
 * in case of more than 6, please update scss file: '.icon-wrapper:nth-child'
 *
 * Parameters:
 * sharedUrl - string. the url that is shared.
 * networks - array of social network names. required.
 * showSneakPeak - boolean. optional. to show a sneak peak of the social shares.
 * onCopyToClipboardSuccess - function. callback function.
 * forceOpen - force open the social share directive on desktop
 * currentState - optional. represents the current state of the pane. so parent controller can read and react.
 *
 * Example:
 * <hb-social-share shared-item-id="networkProjectVm.projectId" networks="['facebook', 'twitter', 'clipboard']" show-sneak-peak="networkProjectVm.openShareProject" />
 *
 */


(function () {
    'use strict';

    Directives.SocialShareDirective = function SocialShareDirective() {

        // @ngInject
        function SocialShareDirectiveControllerFunc($scope, $injector, AnalyticsService, DeviceService,  $timeout, Gon) {

            this.constructor.$super.call(this, $scope, $injector);
            this._objectType = 'SocialShareDirectiveController';
            this.isSocialShareOpenDesktop = false;
            $timeout (function() {
                // timeout for the animation
                this.isSocialShareOpenDesktop = this.forceOpen || false;
                if (this.currentState != undefined) {
                    this.currentState = this.isSocialShareOpenDesktop;
                }
            }.bind(this), 200);
            this.isShowMobileSharingPane = false;
            this.DeviceService = DeviceService;

            this.AnalyticsService = AnalyticsService;
            this.facebookAppId = Gon.facebook_app_id;
            this.$timeout = $timeout;
            this.currTimeout = false;
            this.timeoutClipboard = false;


            $scope.$on('$destroy', function () {
                if (this.currTimeout) {
                    this.$timeout.cancel(this.currTimeout);
                }

                if (this.timeoutClipboard) {
                    this.$timeout.cancel(this.timeoutClipboard);
                }
            }.bind(this));

            if(this.showSneakPeak) {
                $timeout(function () {
                    this.isSocialShareOpenDesktop = true;
                    $timeout(function () {
                        this.isSocialShareOpenDesktop = false;
                    }.bind(this), 5000);
                }.bind(this), 3000);
            }
        }


        var SocialShareDirectiveController = Class(Controllers.BaseController, {

            constructor: SocialShareDirectiveControllerFunc,

            onLinkCopySuccess: function onLinkCopySuccess() {
                this.isLinkCopied = true;
                this.timeoutClipboard = this.$timeout(function () {
                    this.closeMobileSharingPane();
                    this.isLinkCopied = false;
                    if (typeof this.onCopyToClipboardSuccess === "function") {
                        this.onCopyToClipboardSuccess();
                    }
                }.bind(this), 1000);
            },

            toggleSharingPaneDesktop: function toggleSharingPaneDesktop() {
                this.currTimeout = this.$timeout(function() {
                    this.isSocialShareOpenDesktop = !this.isSocialShareOpenDesktop;
                    if (this.currentState != undefined) {
                        this.currentState = this.isSocialShareOpenDesktop;
                    }
                    this.AnalyticsService.track(this, 'hover:' + (this.isSocialShareOpenDesktop ? "in" : "out") + " " + this.analyticsEventName,{});
                }.bind(this), 100);
            },

            toggleMobileSharingPane : function openMobileSharingPane() {

                if (this.DeviceService.checkIfMobileSize()) {
                    // to this stuff only for mobile devices
                    this.isShowMobileSharingPane = !this.isShowMobileSharingPane;
                    this.AnalyticsService.track(this, 'click:' + (this.isShowMobileSharingPane ? "open" : "close") + " " + this.analyticsEventName,{});
                }

            },

            closeMobileSharingPane : function closeMobileSharingPane() {
                if (this.DeviceService.checkIfMobileSize()) {
                    // to this stuff only for mobile devices
                    this.isShowMobileSharingPane = false;
                }
            },

            onSocialShareMouseLeave : function onSocialShareMouseLeave() {
                this.$timeout.cancel(this.currTimeout);
                this.isSocialShareOpenDesktop = false;
            },

            shouldShow : function shouldShow(social_network) {
                return (this.networks.indexOf(social_network) > -1)
            },

            collapseSocialShare : function collapseSocialShare() {
                this.closeMobileSharingPane();
            },

            track: function track(eventProps) {
                var eventProps = eventProps || {};
                this.AnalyticsService.track(this, this.analyticsEventName, _.extend(eventProps, this.analyticsProperties));
            }

        });

        return {
            scope: {
                networks: '=',
                sharedUrl: '=',
                showSneakPeak: '=',
                analyticsEventName: '@',
                analyticsProperties: '=analyticsProperties',
                emailSubject : '=emailSubject',
                emailBody : '=emailBody',
                onCopyToClipboardSuccess : '&',
                forceOpen: '=',
                currentState: '='
            },
            templateUrl: 'angular/app/modules/network/features/social_share/social_share_template.html',
            controller: SocialShareDirectiveController,
            controllerAs: 'socialShareVm',
            bindToController: true
        };
    };


}());






